export const isCircularJson = (json: Record<string, any> | any[]): boolean => {
  const seen = new WeakSet();
  const checkCircular = (obj: any): boolean => {
    if (typeof obj !== 'object' || obj === null) return false;
    if (seen.has(obj)) return true;
    seen.add(obj);
    return Object.values(obj).some(checkCircular);
  };
  return checkCircular(json);
};
